import React from 'react';
import clsx from 'clsx';

interface IconButtonProps {
  state: 'default' | 'selected' | 'disabled';
  className: string;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  iconSelected?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  onClick?: () => void;
  'data-qa-selector'?: string;
}

export const IconButton: React.FC<IconButtonProps> = ({
  className,
  state = 'default',
  icon: Icon,
  iconSelected: IconSelected,
  onClick = () => {},
  'data-qa-selector': dataQaSelector,
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return (
    <button
      onClick={handleClick}
      disabled={state === 'disabled'}
      data-qa-selector={dataQaSelector}
      className={clsx(
        'inline-flex h-9 w-9 items-center justify-center gap-1 rounded-md px-3 py-2 transition-all',
        className,
        {
          'cursor-pointer text-neutral-900 hover:bg-neutral-100': state === 'default',
          'text-neutral-0 cursor-pointer bg-indigo-500': state === 'selected',
          'cursor-not-allowed text-neutral-200': state === 'disabled',
        },
      )}
    >
      {typeof Icon === 'function' &&
        (state === 'default' || state === 'disabled' || IconSelected === null) && (
          <Icon className="h-5.5 min-h-5.5 w-5.5 min-w-5.5 transition-all" />
        )}
      {IconSelected && state === 'selected' ? (
        <IconSelected className="h-5.5 min-h-5.5 w-5.5 min-w-5.5 transition-all" />
      ) : null}
    </button>
  );
};
